export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8448.23e2641c.jpg";